import { LOAD_PORTFOLIO } from './constants';

const portfolios = {
    byIds: {},
    allIds: [],
};

export default (state = portfolios, { type, payload }) => {
    switch (type) {
        case LOAD_PORTFOLIO: {
            return {
                ...state,
                byIds: {
                    [payload.type]: payload,
                },
                allIds: [...state.allIds, payload.type],
            };
        }
        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/portfolio/reducer.js
 **/